/**
 * Internal dependencies
 */
import { hidePdfEmbedsOnUnsupportedBrowsers } from './utils';

hidePdfEmbedsOnUnsupportedBrowsers();
